
import Radio from "../../../assets/outline/Radio.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RadioIcon({ className, dataTestid = "RadioIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Radio data-testid={dataTestid} className={classes} {...rest} />
  );
}
